import React from 'react';

class CreateGameBalancingComponent extends React.Component {
    render() {
        return (<div />);
    }
}
export default CreateGameBalancingComponent;
